import { BaseRoutes } from '@monorepo/tools/src/lib/routes/base.routes';

export class KeysManagementRoutes extends BaseRoutes {
	constructor() {
		super('keys-management');
	}
}
